(function () {
var $f1a44c20b092a9db$var$getViewportWidth = function() {
    return document.querySelector('html').clientWidth;
};
var $f1a44c20b092a9db$var$setDecorativeMaxWidth = function() {
    $f1a44c20b092a9db$var$decorativeElements.forEach(function(el) {
        var enclosingSectionRect = el.closest('section').getBoundingClientRect();
        el.style.setProperty('--max-width', "".concat(($f1a44c20b092a9db$var$getViewportWidth() - enclosingSectionRect.width) / 2, "px"));
    });
};
var $f1a44c20b092a9db$var$decorativeElements = document.querySelectorAll('.decorative-element');
if ($f1a44c20b092a9db$var$decorativeElements.length) {
    $f1a44c20b092a9db$var$setDecorativeMaxWidth();
    window.addEventListener('resize', $f1a44c20b092a9db$var$setDecorativeMaxWidth);
}

})();
//# sourceMappingURL=highlight.min.js.map
